<template>
<div>
    <div id="cores">
        <div class="cor1"></div> 
        <div  class="cor2"></div> 
        <div  class="cor3"></div>
        <div  class="cor4"></div>
    </div>
    <div class="espacamento">
        <div class="top"> 
            <div>
                <span style="font-size:18px;">{{$store.state.titulo.substring(0,5)}}</span><br>
                <p>{{$store.state.titulo.substring(5,10000)}}</p>
            </div>            
            <button class="voltar" @click="voltar">Voltar</button>
        </div>
    <div class="opcoes">
            <div class="bloco cantoEsquerdo" @click="abrirBloco(1,'IRRF','IRRF','GeralIRRF')">
                <p>IRRF</p> 
                <div :class="{select:1==atualSelect}" style="border-bottom-left-radius: 10px;"></div>         
            </div>
            <div class="bloco" @click="abrirBloco(2,'CSRFcontribucoesS','CSRF','GeralCSRF')"> 
                <p>CSRF</p>
                <span>Contribuições Sociais</span>
                 <div :class="{select:2==atualSelect}" ></div>         
            </div>
            <div class="bloco" @click="abrirBloco(3,'COSIRForgaosF','COSIRF - Órgãos Federais','GeralCOSIRF')">
                <p>COSIRF</p>
                <span>Órgãos Federais</span>
                <div :class="{select:3==atualSelect}" ></div>         
            </div>
            <div class="bloco" @click="abrirBloco(4,'CSRForgaosE','CSRF - Órgãos Estaduais / Municipais / Distritais','GeralCSRF_EMD')">
                <p>CSRF</p>
                <span>Órgãos Estaduais Municipais / Distritais</span>
                <div :class="{select:4==atualSelect}" ></div>         
            </div>
            <div class="bloco" @click="abrirBloco(5,'IRRForgaosE','IRRF - Órgãos Estaduais / Municipais / Distritais','GeralRRF_EMD')">
                <p>IRRF </p>
                <span>Órgãos Estaduais Municipais / Distritais</span>
                <div :class="{select:5==atualSelect}" ></div>         
            </div>
            <div class="bloco" @click="abrirBloco(6,'INSS', 'INSS','GeraINSS')">
                <p>INSS</p>
                <div :class="{select:6==atualSelect}" ></div>         
            </div>
            <div class="bloco cantoDireito" @click="abrirBloco(7,'ISS','ISS','ISS')">
                <p>ISS</p>
                <div :class="{select:7==atualSelect}" ></div>      
            </div>
    </div>
    <p class="ronaldo">{{atualTxt}}</p>
      <Geral :isRota="rota" @fn="armazenaFN = $event" v-show="rota != 'ISS'"/>
      <ISS v-if="!(rota != 'ISS')"/>
      <!--<IRRF v-if="!(rota != 'GeralRRF_EMD')"/>-->
    </div>
</div>
</template>

<script>
import Geral from '../components/Geral.vue'
import ISS from '../components/ISS.vue'

export default {
    components:{    
       Geral,
       ISS,
       
    },
    data(){
        return{
            armazenaFN:null,
            atualTxt:'IRRF',
            atualSelect:0,
            componente:'IRRF',
            rota:'GeralIRRF'
        }
    },
    methods:{
        voltar(){
            this.$router.push({name:'rtfonte'})
        },
        abrirBloco(atual,txt,atualTxt,rota){
            if(atual == 8){
                window.open('http://servicos.receita.fazenda.gov.br/Servicos/sicalcweb/default.asp?TipTributo=2&FormaPagto=1','_blank')
            }else{
            
                this.rota = rota
                this.atualTxt = atualTxt
                this.atualSelect = atual
                this.componente = txt
                if(atual != 7 || atual != 5){
                    this.armazenaFN(rota)    
                }               
            }
        }
    },
    mounted(){
        
    }
}
</script>

<style>
.top{
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 20px;
        border-bottom: 1px solid #a09e9e;
    padding-bottom: 5px;
}
.top p{
    margin-bottom: 0px;
    font-size: 18px;
    font-weight: bold;
}
.voltar{
        height: 42px;
    width: 110px;
    border-radius: 7px;
    border: 2px solid #49274a;
    background: #fff;
    color: gray;
    font-style: italic;
    font-weight: 700;
    font-size: 18px;
    cursor: pointer;
    margin-top: 9px;
    margin-left: 25px;
}
.ronaldo{
    margin-left: 7px;
    font-style: italic;
    font-size: 22px;
    font-weight: bold;
    color: rgb(128, 128, 128);
    margin-bottom: 0.6px;
    border-bottom: 1px solid rgb(160, 158, 158);
    margin-top:35px;
}
#cores{
    display: flex;
    height: 45px;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -ms-flex-direction: row;
    flex-direction: row;
}
#cores .cor1 {
    width: 25%;
    background: #49274a;
}
#cores .cor2 {
    width: 25%;
    background: #94618e;
}
#cores .cor3 {
    width: 25%;
    background: #f4decb;
}
#cores .cor4 {
    width: 25%;
    background: #f8eee7;
}
.espacamento{
    padding:30px;
}
.opcoes{
    display: flex;
    align-items: center;
    justify-content: center;
     flex-wrap: wrap;
         margin-top: 35px;
}
.opcoes .select{  
    height:8px;
    width: 100%;
    position: absolute;
    bottom: 0px;
    background:#241923
}
.opcoes .cantoEsquerdo{
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}
.opcoes .cantoDireito{
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}
.opcoes div.bloco{
    background: #94618E;
    width: 144px;
    height: 85px;
    color:#fff;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex-wrap: wrap;
    border-left: 1px solid #fff;
padding: 5px;
cursor: pointer;
position: relative;
}
.opcoes div p{
    font-weight: bold;
    margin:0px;
}
.opcoes div span{
    text-align: center;
    font-size: 13px;
}
</style>